export * from 'epic-diesel-common/src/components/message';
import Message from 'epic-diesel-common/src/components/message';
export default Message;
